import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "./../../guid";

@Component({
  selector: "app-validationrulenew",
  templateUrl: "./validationrulenew.component.html",
  styleUrls: ["./validationrulenew.component.scss"],
})
export class ValidationrulenewComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  // publicAccess = false;
  // visibleMeChecked = false;
  // visibleAllChecked = true;
  fields: Array<any>;
  guid: GUID;

  // filterForm: FormGroup;
  filteritems: FormArray;
  filterForm = this.fb.group({
    filteritems: this.fb.array([]),
    filtertype: "required",
    filterlogic: "",
    active: true,
  });
  metafields = [];

  validationruleName = "";
  metaValidationRuleId = "";

  detailForm = this.fb.group({
    label: "",
    name: "",
    pluralname: "",
    node: "",
    code: new FormControl({ value: "", disabled: true }, Validators.required),
    objecttype: "",
    errormessage: "",
    actiontype: "",
    description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    parentobject: "",
    // errorfield: "",
    errorlocation: "top", // Default value
    errorfield: "",
    embeddedobject: false,
    virtualobject: false,
    active: true,
    allowreports: false,
    publicaccess: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    allowqueuepublishing: false,
    alloweventpublish: false,
    iconname: "",
    errorlocationfieldname: "",
    errorlocationfieldid: "",
    type: "iscriteria",
  });
  mode: any;
  metaobjectId: any;
  metaobjectName: any;
  profileId: any;
  picklistValueList = [];
  fieldList = [];
  operatorList = [];
  typeList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];

  actiontypes = [
    { label: "Create", value: "create" },
    { label: "Update", value: "update" },
    { label: "Both", value: "both" },
  ];
  validationRules: any;
  metaobjectList: any;
  allFields: Array<any>;
  // metaValidationRuleId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.profileId = this.route.snapshot.params.profileid;
      this.validationruleName = this.route.snapshot.params.name;
      this.metaValidationRuleId = this.route.snapshot.params.id;
    });

    console.log("****mode *****", this.mode);
    if (this.mode.toLocaleLowerCase() == "edit") {
      // this.getValidationRuleById();
      // this.addFilterItem("", "", "", [], "", "", "");
    }
    this.guid = new GUID();

    if (this.mode.toLocaleLowerCase() == "new") {
      this.getMetaFieldsForSelection().then((res) => {
        this.retrieveLookupFields().then((res) => {
          console.log("response1111", res);
          // console.log("Field list after processing:", this.allFields);
          // console.log("Field list after processing:", this.fields);

          const fieldsForSelection = [...this.fields, ...this.allFields];

          // //add default --None-- into field list
          // this.fieldList.push({
          //   value: "--None--",
          //   label: "--None--",
          //   fieldtype: "text",
          //   standard: true,
          //   options: [],
          //   id: "",
          // });

          //create fieldlist from fields as readable form by selection control
          for (let i = 0; i < fieldsForSelection.length; i++) {
            var field = fieldsForSelection[i];

            // console.log(field.labelname);

            //skip id type fields if there
            if (field.fieldtype.toLowerCase() == "id") continue;

            //skip fields with visibility false
            if (field.visible == false) continue;

            //skip fields deleted, ownertype etc.,
            if (
              field.fieldname.toLowerCase() == "deleted" ||
              field.fieldname.toLowerCase() == "ownertype" ||
              field.fieldname.toLowerCase() == "migrated" ||
              field.fieldname.toLowerCase() == "organizationid" ||
              field.fieldname.toLowerCase() == "search" ||
              field.fieldname.toLowerCase() == "date_range"
            )
              continue;

            //skip converted field if object is lead
            if (
              this.metaobjectName.toLowerCase().trim() == "lead" &&
              field.fieldname.toLowerCase() == "converted"
            )
              continue;

            //convert to titecase
            var strLabel = field.labelname;
            var formattedLabel = field.metaobjectname + ": " + strLabel;

            strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
            this.fieldList.push({
              // value: field.fieldname,
              value: field.id,
              fieldname: field.fieldname,
              label: formattedLabel,
              fieldtype: field.fieldtype,
              standard: field.standard,
              options: field.options,
              metaobjectname: field.metaobjectname,
              relatedfieldname: field.relatedfieldname,

              // id: field.id,
              id: field.fieldname,
            });
          }

          //load default done list first
          // this.loadDefaultDoneList();

          this.addFilterItem("", "", "", [], "", "", "", "", "", "");
          // this.addFilterItem("", "", "", [], "", "");
          // this.addFilterItem("", "", "", [], "", "");

          // this.isDataLoaded = true;
        });
      });
    } else {
      this.retrieveLookupFields().then((res) => {
        console.log("response1111", res);

        this.getMetaFieldsForSelection().then((res) => {
          console.log("response1111", res);
          // load metalayout details

          const fieldsForSelection = [...this.fields, ...this.allFields];

          this.getValidationRuleById(fieldsForSelection).then(() => {
            // console.log("this.metalayout", this.metalayout);
            // console.log("this.res", res);
            // console.log(this.allFields);
          });
        }); //getMetaLayoutByName()
      });
    }

    // // this.getMetaFieldsForSelection();
    // this.getMetaFieldsForSelection().then((res) => {
    //   console.log("response1111", res);

    //   if (this.mode.toLocaleLowerCase() == "edit") {
    //     this.getValidationRuleById();
    //   }
    //   this.addFilterItem("", "", "", [], "", "", "");
    //   // this.addFilterItem("", "", "", [], "","", "");
    //   // this.addFilterItem("", "", "", [], "","", "");
    // });

    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel,
      });
    }

    for (let i = 0; i < this.appConfig.types.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.types[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.typeList.push({
        value: this.appConfig.types[i],
        label: strLabel,
      });
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  fieldSelected(
    event: {
      id: any;
      fieldtype: any;
      options: string;
      relatedfieldname: any;
      metaobjectname: any;
    },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("relatedfieldname").setValue(event.relatedfieldname || null);
        c.get("metaobjectname").setValue(event.metaobjectname);

        c.get("options").setValue(event.options);
        if (c.get("fieldoperator").value == "") {
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    console.log(index);
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }
  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }
  createfilterItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    typ: any,
    vl: any,
    flogic: string,
    relfieldname: any,
    metaobjectname: any
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      fieldoperator: opr,
      type: typ,
      fieldvalue: vl,
      filterlogic: flogic,
      relatedfieldname: relfieldname,
      // metaobjectname: this.metaobjectName,
      metaobjectname: metaobjectname,
      // filtertype: "",
      // errormessage: "",
      // lookuptext: "",
      // active: "",
    });
  }
  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    typ: any,
    vl: string,
    flogic = "AND",
    relfieldname: any,
    metaobjectname: any
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createfilterItem(
        name,
        id,
        ftype,
        opt,
        opr,
        typ,
        vl,
        flogic,
        relfieldname,
        metaobjectname
      )
    );
    this.picklistValueList.push([]);
  }

  fieldChange(event: { value: string; label: any }) {
    console.log("fieldChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["errorlocationfieldid"].setValue(event.value);
      this.detailForm.controls["errorlocationfieldname"].setValue(event.label);
    } else {
      this.detailForm.controls["parentobjectid"].setValue("");
      this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            // this.metafields = res.data.metafields;
            this.fields = res.data.metafields;

            // var fieldArr = [];
            // //just add an empty entry sice this field is optional
            // fieldArr.push({ value: "", label: "--None--" });
            // for (let i = 0; i < this.metafields.length; i++) {
            //   fieldArr.push({
            //     value: this.metafields[i].id,
            //     label: this.metafields[i].labelname,
            //   });
            // }
            // this.fields = fieldArr;

            // this.fieldList.push({
            //   value: "--None--",
            //   label: "--None--",
            //   fieldtype: "text",
            //   standard: true,
            //   options: [],
            //   id: "",
            // });

            // //create fieldlist from fields as readable form by selection control
            // for (let i = 0; i < this.metafields.length; i++) {
            //   var field = this.metafields[i];
            //   console.log(field);

            //   //skip id type fields if there
            //   if (field.fieldtype.toLowerCase() == "id") continue;

            //   //skip fields with visibility false
            //   if (field.visible == false) continue;

            //   //skip fields deleted, ownertype etc.,
            //   if (
            //     field.fieldname.toLowerCase() == "deleted" ||
            //     field.fieldname.toLowerCase() == "ownertype" ||
            //     field.fieldname.toLowerCase() == "migrated" ||
            //     field.fieldname.toLowerCase() == "organizationid" ||
            //     field.fieldname.toLowerCase() == "search" ||
            //     field.fieldname.toLowerCase() == "date_range"
            //   )
            //     continue;

            //   //skip converted field if object is lead
            //   if (
            //     this.metaobjectName.toLowerCase().trim() == "lead" &&
            //     field.fieldname.toLowerCase() == "converted"
            //   )
            //     continue;

            //   //convert to titecase
            //   var strLabel = field.labelname;

            //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
            //   this.fieldList.push({
            //     value: field.fieldname,
            //     label: strLabel,
            //     fieldtype: field.fieldtype,
            //     standard: field.standard,
            //     options: field.options,
            //     id: field.id,
            //   });

            //   // console.log(this.fieldList);
            // }

            this.isLoading = false;
            resolve(this.fields);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      // this.isLoading = true;
      this.dataService.getObjectLookupFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.metaobjectList = res.metaobject;
            console.log(this.metaobjectList);
            if (this.metaobjectList) {
              // Loop through the metaobjectList and call getMetaFieldsForSelection
              const promises = this.metaobjectList.map((metaobject) => {
                return this.getObjectLookupFieldsForFieldsList(
                  metaobject.relatedobjectid,
                  metaobject.relatedto,
                  metaobject.metafieldname
                );
              });

              Promise.all(promises)
                .then((results) => {
                  // console.log("Promise.all results:", results);

                  // const allFields = [];

                  // Iterate through each result (fields array) and concatenate into allFields
                  // results.forEach((fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     allFields.push(...fields);
                  //   }
                  //   return allFields
                  // });
                  // const allFields = results.reduce((acc, fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     acc.push(...fields);
                  //   }
                  //   return acc;
                  // }, []);
                  const allFields: any = results.reduce(
                    (acc: any[], fields) => {
                      if (fields && Array.isArray(fields)) {
                        acc.push(...fields);
                      }
                      return acc;
                    },
                    []
                  );

                  this.allFields = allFields;

                  // console.log("Combined lookup fields", this.allFields);

                  // this.isLoading = false;
                  resolve(this.allFields); // Resolve with the combined fields
                })
                .catch((err) => {
                  console.log("Error***:", err);
                  this.errorMessage = err.message;
                  this.isError = true;
                  this.isLoading = false;
                  resolve(null);
                });
            }

            // this.isLoading = false;
            // resolve(this.allFields);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        }
      );
    });
  }

  getObjectLookupFieldsForFieldsList(
    metaobjectid: any,
    metaobjectname: any,
    metafieldname: any
  ) {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: metaobjectid,
            metaobjectname: metaobjectname,
          },
        },
      };

      console.log("postOption", postOption);

      // this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            const fields = res.data.metafields;

            // Filter and transform fields before adding them to the fieldList
            fields.forEach((field: any) => {
              field.relatedfieldname = metafieldname;
              if (
                field.fieldtype.toLowerCase() !== "id" &&
                field.visible !== false &&
                ![
                  "deleted",
                  "ownertype",
                  "migrated",
                  "organizationid",
                ].includes(field.fieldname.toLowerCase()) &&
                !(
                  this.metaobjectName.toLowerCase().trim() === "lead" &&
                  field.fieldname.toLowerCase() === "converted"
                )
              ) {
                let strLabel = field.labelname;
                strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              }
            });

            // this.isLoading = false;
            resolve(fields);
            console.log(fields);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getValidationRuleById(allfields: any) {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          validationrule: {
            id: this.metaValidationRuleId,
            name: this.validationruleName,
          },
        },
      };
      console.log(this.metaValidationRuleId);
      console.log(postOption);
      this.isLoading = true;
      this.dataService.getValidationRuleById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.validationRules = res.data.validationrule;
            console.log("Doneeee****", this.validationRules);
            if (this.validationRules != null) {
              // this.fieldsDone = this.process.fields;
              // this.id = this.process.id;
              // this.name = this.process.name;

              this.detailForm.controls["name"].setValue(
                this.validationRules.name
              );
              this.detailForm.controls["description"].setValue(
                this.validationRules.description
              );
              this.detailForm.controls["active"].setValue(
                this.validationRules.active
              );
              this.detailForm.controls["errorlocation"].setValue(
                this.validationRules.errorlocation
              );
              this.detailForm.controls["errormessage"].setValue(
                this.validationRules.errormessage
              );
              // this.detailForm.controls["errorfield"].setValue(
              //   this.validationRules.errordisplayfieldid
              // );
              this.detailForm.controls.errorfield.patchValue(
                this.validationRules.errordisplayfieldid
              );
              this.detailForm.controls["errorlocationfieldid"].setValue(
                this.validationRules.errordisplayfieldid
              );
              this.detailForm.controls["errorlocationfieldname"].setValue(
                this.validationRules.errordisplayfieldname
              );
              this.detailForm.controls["actiontype"].setValue(
                this.validationRules.actiontype
              );
              if (this.validationRules.iscriteria == true) {
                this.detailForm.controls["type"].setValue("iscriteria");
              }
              if (this.validationRules.isformula == true) {
                this.detailForm.controls["type"].setValue("isformula");
              }
              this.filterForm.controls["filterlogic"].setValue(
                this.validationRules.filterlogic
              );
            }

            var criterias = res.data.validationrule.validationrulecriteria;
            var index = 0;
            // console.log(criterias);
            // for (let i = 0; i < criterias.length; i++) {
            //   var criteria = criterias[i];

            //   console.log("fieldname", criteria.fieldname);
            //   //skip id type fields if there
            //   if (criteria.fieldname.toLowerCase() == "deleted") {
            //     console.log("deleted found.");
            //     continue;
            //   }
            //   //skip converted field if object is lead
            //   if (
            //     this.metaobjectName.toLowerCase().trim() == "lead" &&
            //     criteria.fieldname.toLowerCase() == "converted"
            //   ) {
            //     console.log("converted found.");
            //     continue;
            //   }

            //   //get addnl field detail from fields
            //   var fldName = "";
            //   var fldLabel = "";
            //   var fldType = "";
            //   var fldOptions: string;

            //   for (let j = 0; j < this.metafields.length; j++) {
            //     if (this.metafields[j].id == criteria.fieldid) {
            //       console.log(this.metafields[j]);
            //       fldName = this.metafields[j].fieldname;
            //       //convert to titecase
            //       fldLabel = this.metafields[j].labelname;
            //       fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
            //       fldType = this.metafields[j].fieldtype;

            //       if (this.metafields[j].options != null) {
            //         fldOptions = this.metafields[j].options;
            //       }
            //       //console.log("fldOptions", fldOptions);
            //       break;
            //     }
            //   }

            //   //add item
            //   //console.log("criteria.value", criteria.value);
            //   this.addFilterItem(
            //     criteria.fieldid,
            //     fldName,
            //     fldType,
            //     fldOptions,
            //     criteria.operator,
            //     criteria.type,
            //     criteria.value
            //   );
            //   if (fldOptions != null) {
            //     var arr = JSON.parse(fldOptions);
            //     this.picklistValueList[index] = arr;
            //   }

            //   index++;
            // }
            var index = 0;
            for (let i = 0; i < criterias.length; i++) {
              var criteria = criterias[i];

              let finalFieldName = criteria.fieldname;
              let relatedField = null;

              if (finalFieldName && finalFieldName.includes(".")) {
                const parts = finalFieldName.split(".");
                relatedField = parts[0]; // converted_account
                finalFieldName = parts[1]; // actual field
              }

              for (let i = 0; i < allfields.length; i++) {
                var field = allfields[i];

                // console.log(field.fieldname);
                // console.log(criteria);
                // if (field.id === criteria.fieldid) {
                //skip id type fields if there
                if (field.fieldtype.toLowerCase() == "id") continue;

                //skip fields with visibility false
                if (field.visible == false) continue;

                //skip fields deleted, ownertype etc.,
                if (
                  field.fieldname.toLowerCase() == "deleted" ||
                  field.fieldname.toLowerCase() == "ownertype" ||
                  field.fieldname.toLowerCase() == "migrated" ||
                  field.fieldname.toLowerCase() == "organizationid" ||
                  field.fieldname.toLowerCase() == "search" ||
                  field.fieldname.toLowerCase() == "date_range"
                )
                  continue;

                //skip converted field if object is lead
                if (
                  this.metaobjectName.toLowerCase().trim() == "lead" &&
                  field.fieldname.toLowerCase() == "converted"
                )
                  continue;

                //convert to titecase
                var strLabel = field.labelname;
                var formattedLabel = field.metaobjectname + ": " + strLabel;
                // console.log(field)

                strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
                this.fieldList.push({
                  // value: field.fieldname,
                  value: field.id,
                  fieldname: field.fieldname,

                  label: formattedLabel,
                  fieldtype: field.fieldtype,
                  standard: field.standard,
                  options: field.options,
                  metaobjectname: field.metaobjectname,
                  relatedfieldname: field.relatedfieldname,

                  // id: field.id,
                  id: field.fieldname,
                });
                // }
              }

              // console.log("fieldname", criteria.fieldname);
              //skip id type fields if there
              if (criteria.fieldname.toLowerCase() == "deleted") {
                console.log("deleted found.");
                continue;
              }
              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                criteria.fieldname.toLowerCase() == "converted"
              ) {
                console.log("converted found.");
                continue;
              }

              //get addnl field detail from fields
              var fldName = "";
              var fldLabel = "";
              var fldType = "";
              var fldOptions: string;
              var fldId = "";

              // console.log(allfields);

              for (let j = 0; j < allfields.length; j++) {
                if (allfields[j].id == criteria.fieldid) {
                  console.log(allfields[j].id);
                  fldName = allfields[j].fieldname;
                  fldId = allfields[j].id;
                  //convert to titecase
                  fldLabel = allfields[j].labelname;
                  fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
                  fldType = allfields[j].fieldtype;

                  if (allfields[j].options != null) {
                    fldOptions = allfields[j].options;
                  }
                  //console.log("fldOptions", fldOptions);
                  break;
                }
              }

              //add item
              // console.log("criteria", criteria);
              const value =
                fldType === "checkbox"
                  ? Boolean(criteria.value)
                  : criteria.value;

              // this.addFilterItem(
              //   // criteria.fieldid,
              //   fldId,
              //   fldName,
              //   fldType,
              //   fldOptions,
              //   criteria.operator,
              //   criteria.type,
              //   // criteria.value
              //   value,
              //   "1",
              //   field.relatedfieldname,
              //   criteria.lookupmodulename
              // );
              this.addFilterItem(
                fldId,
                finalFieldName, // ✅ clean field name
                fldType,
                fldOptions,
                criteria.operator,
                criteria.type,
                value,
                "1",
                relatedField, // ✅ only if lookup
                criteria.lookupmodulename
              );

              if (fldOptions != null) {
                var arr = JSON.parse(fldOptions);
                this.picklistValueList[index] = arr;
              }

              index++;
            }
            this.isLoading = false;
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      );
    });
  }

  cancel() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  save() {
    this.isLoading = false;
    this.isError = false;

    console.log("mode", this.mode);

    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }

    if (this.detailForm.controls["actiontype"].value.toString().trim() == "") {
      this.showWarning("Actiontype is mandatory");
      return;
    }
    // if (
    //   this.detailForm.controls["type"].value.toString().trim() == "iscriteria"
    // ) {
    //   this.filterForm.controls["filteritems"].value[0].fieldid != "";
    //   this.showWarning("Filter is mandatory");
    //   return;
    // }

    // console.log(this.filterForm.controls["filteritems"]);
    // console.log(this.detailForm);

    if (this.mode.toLocaleLowerCase() == "new") {
      this.metaValidationRuleId = this.guid.getGUID("metavalidationrule");
    }
    var isCriteria: boolean;
    if (this.detailForm.controls["type"].value == "iscriteria") {
      isCriteria = true;
    } else {
      isCriteria = false;
    }

    var isFormula: boolean;
    if (this.detailForm.controls["type"].value == "isformula") {
      isFormula = true;
    } else {
      isFormula = false;
    }

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profilename: userDetail.profilename,
      data: {
        validationrule: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          mode: this.mode,
          id: this.metaValidationRuleId,
          name: this.detailForm.controls["name"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          active: this.detailForm.controls["active"].value,
          iscriteria: isCriteria,
          isformula: isFormula,
          filterlogic: this.filterForm.controls["filterlogic"].value,
          formulatext: "",
          actiontype: this.detailForm.controls["actiontype"].value,
          errorlocation: this.detailForm.controls["errorlocation"].value,
          errordisplayfieldid:
            this.detailForm.controls["errorlocationfieldid"].value,
          errordisplayfieldname:
            this.detailForm.controls["errorlocationfieldname"].value,
          errormessage: this.detailForm.controls["errormessage"].value,
          validationrulecriteria: [],
          validationrulejsontext: {},
        },
      },
    };

    var arrfilters = [];

    var arrayControl = this.filterForm.get("filteritems") as FormArray;

    for (let c of arrayControl.controls) {
      console.log(c);
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;
      var type = c.get("type").value;
      var operator = c.get("fieldoperator").value;
      var metaObjectName = c.get("metaobjectname").value;
      console.log("metaObjectName", metaObjectName);
      if (
        operator.toLowerCase().trim() == "--none--" ||
        operator.toLowerCase().trim() == ""
      )
        operator = "";

      var value = c.get("fieldvalue").value;
      var relatedfieldname = c.get("relatedfieldname").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        var lookupFilter = {
          id: this.guid.getGUID("metavalidationrulecriteria"),
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          // metaobjectname: metaObjectName,
          validationruleid: this.metaValidationRuleId,
          // fieldid: fieldId,
          // fieldname: fieldName,
          fieldid: fieldName,
          fieldname: fieldId,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          type: type,
          lookupmodulename: metaObjectName,
          filterlogic: c.get("filterlogic").value,
          // filterlogic: this.filterForm.controls["filterlogic"].value,
          filtertype: this.filterForm.controls["filtertype"].value,
          active: this.filterForm.controls["active"].value,
        };
        // if (relatedfieldname) {
        //   lookupFilter.fieldname = `${relatedfieldname}.${fieldId}`;
        // } else {
        //   lookupFilter.fieldname = fieldId;
        // }

        if (relatedfieldname && !fieldId.includes(".")) {
          lookupFilter.fieldname = `${relatedfieldname}.${fieldId}`;
        } else {
          lookupFilter.fieldname = fieldId;
        }
        //push it to array
        arrfilters.push(lookupFilter);
      }
    }
    postOption.data.validationrule.validationrulecriteria = arrfilters;

    console.log("filter *****", arrfilters);

    var validationJson = {
      id: this.guid.getGUID("metavalidationrule"),
      metaobjectid: this.metaobjectId,
      metaobjectname: this.metaobjectName,
      validationruleid: this.metaValidationRuleId,
      actiontype: this.detailForm.controls["actiontype"].value,
      jsontext: {},
    };

    postOption.data.validationrule.validationrulejsontext = validationJson;

    console.log(postOption);

    this.isLoading = true;
    this.dataService.upsertValidationRule(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
